import { createEnvelopeSource } from './create-envelope-source';

/**
 * The engagement-drivers-rpp source over the standardized envelope
 * (`GET /analytics/engagement-drivers-rpp`). Two `bars` breakdowns: `badge`
 * (metric `badgeEarnRate`) and `bonusAction` (metric `bonusCompletionRate`).
 * Each row carries an absolute rate, its base, and, for repeatable bonus
 * actions, an average-times-completed sub-line. National only (no region).
 */
export const engagementDriversRppSource = createEnvelopeSource({
    label: 'Engagement drivers',
    endpoint: 'analytics/engagement-drivers-rpp',
    metrics: [
        { id: 'badgeEarnRate', label: 'Badge earn rate', type: 'ratio' },
        {
            id: 'bonusCompletionRate',
            label: 'Bonus completion rate',
            type: 'ratio',
        },
    ],
    forms: ['bars'],
    regionGrain: 'national',
});
